import { Backdrop, CircularProgress } from "@mui/material";

interface LoadingOverlayProps {
  isLoading: boolean;
}
/**
 * to handle loading state while api call
 *
 * @param isLoading @type {boolean}
 *
 * @author rajkumar rathod
 */
const LoadingOverlay = ({ isLoading }: LoadingOverlayProps) => (
  <Backdrop
    sx={(theme) => ({
      color: "primary",
      zIndex: theme.zIndex.modal + 1,
    })}
    open={isLoading}
  >
    <CircularProgress color="inherit" />
  </Backdrop>
);

export default LoadingOverlay;
